import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { tap, take } from 'rxjs';

import { DomainState } from '@common/store/domain.store';
import { Domain } from '@common/types';
import { isEmpty } from '@common/util/util';

@Injectable({
  providedIn: 'root',
})
export class DomainService {
  constructor(
    private httpClient: HttpClient,
    private domainState: DomainState,
  ) {}

  fetchDomainInfo() {
    // Create and store the shared Observable
    return this.httpClient.get<Domain>('/api/domain').pipe(
      take(1),
      tap((domain: Domain) => {
        if (!isEmpty(domain)) {
          this.domainState.update(domain);
        }
      }),
    );
  }
}
